import {
	Pipe,
	PipeTransform,
} from '@angular/core';
import { commonUtilitiesCoreService } from '../services/core.service';

@Pipe({
	name: 'commonVersionFormatter',
})
export class CommonVersionFormatterPipe implements PipeTransform {
	transform (version: number | undefined): string {
		version = version || 0;

		if (!commonUtilitiesCoreService.hasValue(version)) {
			return '';
		}

		if (Number.isInteger(version)) {
			return `${ version }.0`;
		} else {
			return version.toString(10);
		}
	}
}
